import { useState } from "react"
import './RowMetas.css'

import expandMetasIcon from '../../assets/img/admin-expand-metas.png'

//Import das imagens dos animais
import leaoImagem from '../../assets/img/leao.svg'
import tigreImagem from '../../assets/img/tigre.svg'
import pinguimImagem from '../../assets/img/pinguim.svg'
import girafaImagem from '../../assets/img/girafa.svg'
import hipopotamoImagem from '../../assets/img/hipopotamo.svg'
import zebraImagem from '../../assets/img/zebra.svg'
import jaguarImagem from '../../assets/img/jaguar.svg'
import vacaLeiteiraImagem from '../../assets/img/vaca.svg'
import suricatoImagem from '../../assets/img/suricato.svg'

function RowMetas({ meta, selectedYear, selectedMonth, manageMetas }) {
    const [ showNiveis, setShowNiveis ] = useState(false)
    //Id animal -> icone
    const iconsMap = {
        1: leaoImagem,
        2: tigreImagem,
        3: pinguimImagem,
        4: girafaImagem,
        5: zebraImagem,
        6: hipopotamoImagem,
        7: jaguarImagem,
        8: vacaLeiteiraImagem,
        10: suricatoImagem,
        11: zebraImagem
    }

    return (
        <>
            <tr className={`adm-table-row row-metas-animais ${meta.desabilitado ? 'desabilitada' : ''}`}>
                <td>
                    <button className="expand-icon-btn" onClick={() => setShowNiveis(value => !value)}>
                        <img className={`expand-icon ${showNiveis ? 'opened' : ''}`} src={expandMetasIcon} alt="expandir metas" />
                    </button>
                </td>
                <td>
                    <div className="nome-column">
                        <img className="animal-icon" src={iconsMap[meta.id_animal]} alt={`${meta.nome} icone`} />
                        {meta.nome}
                    </div>
                </td>
                <td style={{paddingRight: '15px'}}>{meta.resumo}</td>
                <td className="tipo-column" style={{paddingRight: '15px'}}>{meta.tipo}</td>
                <td style={{paddingRight: '15px'}}>{meta.desabilitado ? 'Desabilitada' : 'Habilitada' }</td>
                <td className="acao-column">
                    <button 
                        className="manage-meta-btn" 
                        onClick={manageMetas}
                        
                    >Alterar métricas</button>
                </td>
            </tr>
            {showNiveis &&
                <tr className={`niveis-metas-animais-row ${meta.desabilitado ? 'desabilitada' : ''}`}>
                    <td className={`niveis-metas-animais-wrapper ${meta.desabilitado ? 'desabilitada' : ''}`} colSpan={"100%"}>
                        <table className="adm-table niveis-metas-animais">
                            <thead>
                                <tr>
                                    <th className="nivel-column">Nível</th>
                                    <th>Meta</th>
                                    <th>Pontos</th>
                                </tr>
                            </thead>
                            <tbody>
                                {meta?.valor_base != null &&
                                    <tr key='valor-base' className="adm-table-row">
                                        <td className="nivel-column">Meta base</td>
                                        <td colSpan={3}>{parseInt(meta.valor_base).toLocaleString('pt')}
                                        </td>
                                    </tr>
                                }
                                {meta.metas.map(metaNivel => 
                                    <tr key={metaNivel.nivel} className="adm-table-row">
                                        <td className="nivel-column">{metaNivel.nivel}</td>
                                        <td>{ metaNivel.meta === null 
                                                ? '--' 
                                                : parseFloat(metaNivel.meta).toLocaleString('pt', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + (meta.tipo_percentual ? '%' : '')}
                                        </td>
                                        <td>{ metaNivel.pontos === null
                                                ? '--'
                                                : parseInt(metaNivel.pontos).toLocaleString('pt') }
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </td>
                </tr>
            }
        </>
    )
}

export default RowMetas